import { OfferApplicantValue } from "@services/offerApplicant/offerApplicant.type";

interface BuildOfferApplicantPropsInterface {
    uuid: string;
    fullName?: string;
    emailAddress?: string;
    phoneNumber?: string;
    coverLetter?: string;
    recruiterEmail?: string;
    offer?: string;
    status?: string;
    assesment?: string;
    answeredQuestions?: { question: string; answer: string }[];
    isAnsweredAllQuestions?: boolean;
    language?: string;
    availability?: string;
    expectedSalary?: string;
    submittedLanguage?: string;
}

export const buildOfferApplicantProps = (input: BuildOfferApplicantPropsInterface) => {
    return {
        "uuid": input.uuid,
        [OfferApplicantValue.group]: {
            [OfferApplicantValue.subGroup.information]: {
                [OfferApplicantValue.field.fullName]: input.fullName,
                [OfferApplicantValue.field.emailAddress]: input.emailAddress,
                [OfferApplicantValue.field.phoneNumber]: input.phoneNumber,
                [OfferApplicantValue.field.coverLetter]: input.coverLetter,
                [OfferApplicantValue.field.offer]: input.offer,
                [OfferApplicantValue.field.status]: input.status,
                [OfferApplicantValue.field.assesment]: input.assesment,
                [OfferApplicantValue.field.answeredQuestions]: input.answeredQuestions,
                [OfferApplicantValue.field.isAnsweredAllQuestions]: input.isAnsweredAllQuestions,
                [OfferApplicantValue.field.language]: input.language,
                [OfferApplicantValue.field.availability]: input.availability,
                [OfferApplicantValue.field.expectedSalary]: input.expectedSalary,
                [OfferApplicantValue.field.submittedLanguage]: input.submittedLanguage,
                [OfferApplicantValue.field.recruiterEmail]: input.recruiterEmail
            }
        }
    }
}